import { Column } from "@hightouch/htui";
import {
  MediaDetailHeader,
  MediaDetailHeaderSkeleton,
} from "src/components/media-detail";
import { EntityTiles } from "src/pages/ad-studio/insights/entity-tiles";
import { EntityNotFound } from "src/pages/ad-studio/insights/entity-not-found";
import { FailureAlert } from "src/pages/ad-studio/insights/performance/failure-alert";
import type {
  CubeQueryFailure,
  EntityHeader,
  Found,
  InsightsQueryResult,
} from "src/pages/ad-studio/insights/performance/types";

export const EntityHeaderSection = ({
  header,
  notFoundHeading,
}: {
  header: InsightsQueryResult<Found<EntityHeader>, CubeQueryFailure>;
  notFoundHeading: string;
}) => {
  switch (header.status) {
    case "loading": {
      return <MediaDetailHeaderSkeleton />;
    }
    case "failed": {
      return <FailureAlert failure={header.failure} />;
    }
    case "loaded": {
      const found = header.value;
      switch (found.kind) {
        case "not-found": {
          return <EntityNotFound heading={notFoundHeading} />;
        }
        case "found": {
          const shown = found.value;
          return (
            <Column gap={6}>
              <MediaDetailHeader
                title={shown.title}
                metaTags={shown.tags}
                statuses={shown.statuses}
                notes={shown.notes}
              />
              <EntityTiles tiles={shown.tiles} />
            </Column>
          );
        }
        default: {
          return found satisfies never;
        }
      }
    }
    default: {
      return header satisfies never;
    }
  }
};
